import React from "react";

const isObjectRef = <T>(
    ref: React.Ref<T>,
): ref is React.MutableRefObject<T | null> =>
    typeof ref === "object" && ref !== null;

/**
 * Wrappers that clone an element to attach their own ref must not
 * clobber a ref the consumer already placed on it; this fans the node
 * out to every ref.
 */
export const mergeRefs =
    <T>(refs: Array<React.Ref<T> | undefined>) =>
    (node: T | null) => {
        refs.forEach((ref) => {
            if (typeof ref === "function") {
                ref(node);
            } else if (ref && isObjectRef(ref)) {
                ref.current = node;
            }
        });
    };
